module.exports = __webpack_public_path__ + "static/disability_card_img4@2x-5ee60cf61bddd41dbb5b4ce50df7a491.jpg";